import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useAppRoute = defineStore('appRoute', () => {
  const route = ref(null);
  const previousRoute = ref(null);

  /**
   * Updates the current route and stores the previous route
   *
   * @param {Object} newRoute - Vue Router route object
   * @param {string} newRoute.fullPath - Full path including query string (e.g., "/view/16454518?view=chrome")
   * @param {string} newRoute.path - Path portion of the route (e.g., "/view/16454518")
   * @param {Object} newRoute.query - Query parameters object (e.g., { view: "chrome" })
   * @param {string} newRoute.hash - Hash portion of the URL (e.g., "")
   * @param {string} newRoute.name - Route name (e.g., "editor-view")
   * @param {Object} newRoute.params - Route parameters object (e.g., { id: "16454518" })
   * @param {Array} newRoute.matched - Array of matched route records
   * @param {Object} newRoute.meta - Route meta information (e.g., { authStateRequired: "either", timer: 6000, title: title() })
   * @param {Object|undefined} newRoute.redirectedFrom - Route object if redirected, undefined otherwise
   * @param {string} newRoute.href - Full href including base path (e.g., "/app/view/16454518?view=chrome")
   */
  const updateRoute = (newRoute) => {
    previousRoute.value = route.value;
    route.value = newRoute;
  };

  const isChromeView = computed(() => (route.value?.query?.view || '').toLowerCase() === 'chrome');

  return {
    route,
    previousRoute,
    updateRoute,
    isChromeView,
  };
});
